import React from "react";
import { IconProp } from ".";
export default function TopArrowIcon(props: IconProp) {
    const { className, width = 20, height = 20, color = "black", onClick } = props;
    return (
        <svg className={className} onClick={onClick} xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 20 20" fill="none">
            <path className={className}
                d="M4.16663 6.6665L9.99996 12.4998L15.8333 6.6665"
                stroke={color}
                strokeWidth="1.66667"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}
